import React from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from 'reducers';
import { roleCategories } from 'utils/constants';
import { useUserRoleMatchCategory } from 'utils/hooks';

import InvestorDashboard from '../investor-pages/InvestorDashboard';
import ServicerDashboard from './admin-servicers/ServicerDashboard';
import AdminDistributorDashboard from './admin-distributors/AdminDistributorDashboard';
import ProviderDashboard from './providers/ProviderDashboard';

const Dashboard = () => {
    const internalUser = useSelector(userSelectors.getInternalUser);
    const currentSubscription = useSelector(userSelectors.getCurrentSubscription);
    const userIsInvestor = useUserRoleMatchCategory(roleCategories.INVESTORS);
    const userIsDistributor = useUserRoleMatchCategory([
        roleCategories.DISTRIBUTORS,
        roleCategories.ADMIN_DISTRIBUTORS,
    ]);
    const userIsProvider = useUserRoleMatchCategory(roleCategories.PROVIDERS);

    if (currentSubscription && userIsInvestor) {
        return <InvestorDashboard internalUser={internalUser} />;
    } else if (currentSubscription && userIsDistributor) {
        return <AdminDistributorDashboard />;
    } else if (currentSubscription && userIsProvider) {
        return <ProviderDashboard internalUser={internalUser} />;
    }

    return currentSubscription ? <ServicerDashboard /> : null;
};

export default Dashboard;
